export default __webpack_public_path__ + "static/068-0cb49fa22036c670991d780dfa3565ed.jpg";